import { MutationVars } from '../common/mutation';

export interface UpdateEmailRequestBody {
  email: string;
}

export type UpdateEmailResponseBody = void;

export type UpdateEmailMutationVars = MutationVars<
  {
    userId: string;
  },
  UpdateEmailRequestBody
>;

export type UpdateEmailMutationFn = (vars: UpdateEmailMutationVars) => Promise<UpdateEmailResponseBody>;
